export const coreStatModules = [];
